import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useOnQueryError } from "@/hooks";
import { HydraErrorResponse } from "@/types";
import queryClient from "@/lib/query-client";
import { SettingsService } from "../services";
import { EditSettingsRequestPayload, SettingsSuccessResponse } from "../types";

const useEditSettings = (id: number | null, showSuccessNotification = true) => {
  const onError = useOnQueryError("settings.edit.default_error");
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation("coi-platform-translations");

  return useMutation<SettingsSuccessResponse, AxiosError<HydraErrorResponse>, EditSettingsRequestPayload>({
    mutationKey: ["edit-settings"],
    mutationFn: (data) => SettingsService.edit(id, data),
    onError,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["settings-list"] });

      if (showSuccessNotification) {
        enqueueSnackbar(t("settings.edit.success_message"), { variant: "success" });
      }
    },
  });
};

export default useEditSettings;
